module.exports = __webpack_public_path__ + "img/shiyong.af3315a9.png";